// extracted by mini-css-extract-plugin
var _1 = "XyNlU";
var _2 = "bg9YH";
export { _1 as "cardSlider", _2 as "cardSliderContent" }
